<template>
	<div class="l-achievement-container">
		<div :class="{
			'l-achievement-wrapper': menuIndex == AWARD_TYPE.TERM,
			'l-achievement-wrapper-medal': menuIndex == AWARD_TYPE.BOOK,
			'l-achievement-wrapper-token': menuIndex == AWARD_TYPE.MONTH,
		}">
			<swiper ref="mySwiper" :options="swiperOption" class="swiper-no-swiping">
				<swiper-slide v-for="item in swiperData" :key="item.id" :class="{ 'l-swiper-transition': isChange }">
					<template v-if="menuIndex == AWARD_TYPE.BOOK">
						<img :src="item.lockingImgUrl" class="l-swiper-img" /></template>
					<template v-if="menuIndex == AWARD_TYPE.MONTH">
						<img v-if="item.userId" :src="item.unlockImgUrl" class="l-swiper-img" />
						<img v-else :src="item.unlockImgUrl" class="l-swiper-img" />
					</template>
					<template v-if="menuIndex == AWARD_TYPE.TERM">
						<img :src="item.imgGifUrl" class="l-swiper-img" />
					</template>
				</swiper-slide>
			</swiper>
		</div>
		<Menu @onChangeMenu="onChangeMenu" :isFulfillList="isFulfillList" :type="menuIndex" :clocked="!isClocked" />
		<Navigation :disabled="isClocked" :name="swiperData[activeIndex] ? swiperData[activeIndex].name : ''" :dateName="swiperData[activeIndex] &&
			swiperData[activeIndex].getStatus !== 0
			? `${new Date(
				swiperData[activeIndex].createTime
			).toLocaleDateString()}`
			: '未获得'
			" :menuIndex="menuIndex" />
		<!-- 通关令牌 -->
		<BackToken v-show="menuIndex == AWARD_TYPE.MONTH" @onSelect="onTokenYear" :yearValue="listFormData.year"
			v-bind="monthData" :disabled="!isClocked"></BackToken>
		<!-- 段位勋章 -->
		<BackMedal v-show="menuIndex == AWARD_TYPE.BOOK" @onTabChange="onMedalTab" :tabNumber="listFormData.medalType"
			:disabled="!isClocked" :isFulfillList="isFulfillList"></BackMedal>
		<!-- 赛季奖杯 -->
		<BackCup v-show="menuIndex == AWARD_TYPE.TERM"></BackCup>
		<GetTokenPopup @medalCoin="onMedalCoin()" v-bind="getTokenPopupData"></GetTokenPopup>
	</div>
</template>

<script>
import Menu from "./components/menu"
import Navigation from "./components/navigation"
import { swiper, swiperSlide } from "vue-awesome-swiper"
import "swiper/dist/css/swiper.css"
import defaultImg from "./images/default.png"
import Class2 from "@/models/classcore"
import BackCup from "./components/back-cup"
import BackToken from "./components/back-token"
import BackMedal from "./components/back-medal"
import { AWARD_TYPE } from "./constants/enum.js"
import GetTokenPopup from "./components/get-token-popup"
const class2 = new Class2()
let vm

export default {
	name: "l-achievement-container",
	components: {
		Menu,
		Navigation,
		swiper,
		swiperSlide,
		BackCup,
		BackToken,
		BackMedal,
		GetTokenPopup,
	},
	data() {
		return {
			AWARD_TYPE,
			source: [],
			isClocked: false, // 锁住左右切换按钮
			isChange: false, // 是否切换
			activeIndex: 0, // C位
			menuIndex: AWARD_TYPE.MONTH, //当前选项卡位置
			defaultImg:
				"https://bhbl-prod.oss-cn-beijing.aliyuncs.com/bhbl/achievement/default.png",
			lastData: {
				id: 999,
				cupShowUrl: defaultImg,
				cupName: "敬请期待",
				name: "敬请期待",
			},
			swiperData: [],
			swiperOption: {
				// 轮播图配置
				watchSlidesProgress: true,
				slidesPerView: 3,
				centeredSlides: true,
				autoplay: false,
				speed: 500,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
				on: {
					// 切换事件
					slideChange: function () {
						vm.activeIndex = this.activeIndex
						vm.timer = null
						if (vm.isCanChange) {
							vm.isChange = true
						}
					},
					resize: function () {
						if (vm.timeSize) {
							vm.onClearTime(vm.timeSize)
							// TODO：注。尺寸变化一直在触发只有当停止变化后，才不会清除时间对象触发更新函数所以不需要return
							// return;
						}
						vm.timeSize = setTimeout(() => {
							vm.swiper.update()
						}, 500) //延时器很重要，不加可能会出错;2022年5月27日,此处更新为防抖函数,页面变化停止后执行swiper.update()函数
					},
				},
			},
			//列表参数
			listFormData: {
				type: 2, //默认为令牌
				year: new Date().getFullYear(),
				medalType: 2, //默认为武官阶
			},
			//令牌月份
			monthData: {},
			//是否可以进行动画效果
			isCanChange: false,
			//防抖时间对象
			timeSize: null,
			//控制领取弹窗组件
			getTokenPopupData: {
				isShow: false,
				coinNumber: 0,
				tokenName: "",
				tokenImg: "",
				textName: "",
			},
			//控制提示数组
			isFulfillList: [],
		}
	},
	computed: {
		swiper() {
			return this.$refs.mySwiper.swiper
		},
	},
	watch: {
		menuIndex() {
			this.swiper.slideTo(0, 0, false)
			this.listFormData.year = new Date().getFullYear()
			this.listFormData.medalType = 2
			this.onGetAllList()
		},
		activeIndex() {
			this._setTokenName()
		},
	},
	created() {
		vm = this // 指向vue
		this.onGetAllList()
	},
	methods: {

		//根据tab值获取列表
		onGetAllList() {
			this.swiperData = []
			this.isCanChange = false
			switch (this.menuIndex) {
				case AWARD_TYPE.MONTH:
					this.onGetHonorList('MONTH')
					break
				case AWARD_TYPE.TERM:
					this.onGetHonorList('TERM')
					break
				case AWARD_TYPE.BOOK:
					this.onGetHonorList('BOOK')
					break
			}
		},
		//获取令牌列表
		onGetHonorList(type) {
			this.isCanChange = false
			class2.getAward({ type }).then(async (res) => {
				this.source = res.data
				let list = []
				res.data.forEach((element) => {
					if (this.menuIndex === AWARD_TYPE.TERM) {
						list.push({
							...element,
						})
					} else if (this.menuIndex === AWARD_TYPE.BOOK) {
						if (element.medalType === this.listFormData.medalType) {
							list.push({
								...element,
							})
						}
					} else if (this.menuIndex === AWARD_TYPE.MONTH) {
						if (element.year === this.listFormData.year) {
							list.push({
								...element,
							})
						}
					}
				})
				this.swiperData = list
			})
		},
		//令牌年份选择
		onTokenYear(year) {
			this._setTokenName()
			this.swiperData = []
			this.listFormData.year = year
			this.isChange = false
			this.isCanChange = false
			this.swiper.slideTo(0, 0, false)
			this.onGetAllList()
		},
		//文阶武阶切换
		onMedalTab(number) {
			let list = []
			this.isChange = false
			this.isCanChange = false
			this.swiperData = []
			this.listFormData.medalType = number
			this.source.forEach(element => {
				if (element.medalType === this.listFormData.medalType) {
					list.push({
						...element,
					})
				}
			})
			this.swiperData = list
		},
		//切换tab类型
		onChangeMenu(code) {
			this.menuIndex = code
			this.isChange = false
			this.isCanChange = false
		},
		// 增加最后的灰色奖杯
		_pushLast() {
			this.swiperData.push(this.lastData)
		},
		//显示文字处理,图片预加载
		_setName() {
			let images = new Array()
			for (let i = 0;i < this.swiperData.length;i++) {
				images[i] = new Image()
				if (this.swiperData[i].getStatus == 2) {
					this.swiperData[i].showUrl =
						this.swiperData[i].unlockImgUrl
					images[i].src = this.swiperData[i].unlockImgUrl
				} else {
					this.swiperData[i].showUrl = this.swiperData[i].lockImgUrl
					images[i].src = this.swiperData[i].lockImgUrl
				}
			}
		},
		_setTokenName() {
			// TODO:常量
			if (this.menuIndex === AWARD_TYPE.MONTH) {
				this.monthData.active = this.swiperData[this.activeIndex]
					? this.swiperData[this.activeIndex].month
					: null
				this.monthData.prev = this.swiperData[this.activeIndex - 1]
					? this.swiperData[this.activeIndex - 1].month
					: null
				this.monthData.next = this.swiperData[this.activeIndex + 1]
					? this.swiperData[this.activeIndex + 1].month
					: null
			}
		},
		// 预加载动图
		_preImg() {
			let images = new Array()
			for (let i = 0;i < this.swiperData.length;i++) {
				images[i] = new Image()
				images[i].src =
					this.menuIndex == AWARD_TYPE.TERM
						? this.swiperData[i].cupEffectUrl
						: this.swiperData[i].lockingImgUrl
			}
			// 点亮奖杯
			if (this.menuIndex == AWARD_TYPE.TERM) {
				this._autoLight()
			} else {
				this._autoLightMedal()
			}
		},
		// 重置数据
		async onReset() {
			location.reload()
		},
		//清除时间对象
		onClearTime(obj) {
			clearTimeout(obj)
			obj = null
		},
	},
}
</script>

<style lang="stylus">
@import './index.styl';

.reset {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 10px;
    cursor: pointer;
    background-color: #000;
    color: #fff;
    opacity: 0.5;
    z-index: 100;
}
</style>
